import ViewLogs from "./view-logs";

export default ViewLogs;